import { PublishingFormLocalItemResult, PublishingFormLocalResult } from "./models/formTemplatesTypes";
import { HttpClient } from "helpers";
import { AxiosResponse } from "axios";
import { BaseResponseType, DataGridRequest, PagedResponseType } from "services/shared-models/sharedTypes";
import { CreatePublishingFormRequest } from "views/home/formTemplates/FormView/templatesForm.schema";

export const FormTemplatesService = {
  getAllFormTemplates: async (request: DataGridRequest) => {
    return await HttpClient.post<PagedResponseType<PublishingFormLocalResult>>(
      `/api/PublishingForm/GetAllPublishingForms`,
      request,
    );
  },
  getById: async (templateFormId: number) => {
    return await HttpClient.get<BaseResponseType<PublishingFormLocalItemResult>>(
      `/api/PublishingForm/GetPublishingFormById/${templateFormId}`,
    );
  },
  create: async (request: CreatePublishingFormRequest) => {
    return await HttpClient.post<BaseResponseType<any>>(`/api/PublishingForm/CreatePublishingForm`, request);
  },
  update: async (templateFormId: number, request: CreatePublishingFormRequest) => {
    return await HttpClient.put<BaseResponseType<any>>(
      `/api/PublishingForm/UpdatePublishingForm/${templateFormId}`,
      request,
    );
  },
  delete: async (templateFormId: number) => {
    return await HttpClient.delete<BaseResponseType<any>>(`/api/PublishingForm/DeletePublishingForm/${templateFormId}`);
  },
  swapOrder: async (from: { id: number; order: number }, to: { id: number; order: number }) => {
    return await HttpClient.post<BaseResponseType<any>>("/api/PublishingForm/SwapOrderForm", {
      from,
      to,
    });
  },
  exportToExcel: async (request: DataGridRequest) => {
    console.log(request);
    return await HttpClient.post<AxiosResponse<Blob>>(`/api/PublishingForm/ExportPublishingFormToExcel`, request, {
      responseType: "blob",
    });
  },
};
